import { atom } from 'jotai';

/**
 * State for the inline presentation editor panel.
 * When open, the SlideEditorPanel appears as a side panel within the chat view.
 */
export interface PresentationPreviewState {
  /** Whether the presentation panel is open */
  isOpen: boolean;
  /** The presentation ID to fetch and display */
  presentationId: string | null;
}

/**
 * Atom to control the inline presentation editor panel.
 * Set presentationId to open, set isOpen to false to close.
 */
export const presentationPreviewAtom = atom<PresentationPreviewState>({
  isOpen: false,
  presentationId: null,
});
